import { render, staticRenderFns } from "./PasswordResetRequestModal.vue?vue&type=template&id=b4782afe&scoped=true&"
import script from "./PasswordResetRequestModal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetRequestModal.vue?vue&type=style&index=0&id=b4782afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4782afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
